export const GET_IMAGE_BLOCK_BY_ID = (id, preview: boolean) => `
  query {
    imageBlock(id: "${id}", preview: ${preview}) {
    sys{id}
      name
      ivImage
      imageDescription
      link {
        globalLinkItem
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
          }
        }
        url
        newTab
      }
      enableZoom
      shareImage
      squareImage
      shareHeading
      shareLinkText
      shareRichtext
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
